/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import React from 'react';
import InvoiceStatusDropdown from 'domain/finance/invoice/shared/input/InvoiceStatusDropdown';

const InvoiceStatusFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <InvoiceStatusDropdown source={source} />
    </DropDownFilter>
  );
};

export default InvoiceStatusFilter;
